import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import { Radio } from '@bingads-webui-react/radio';

import { CommentsField } from './comments-field';
import {
  REASON_TABLE,
  OTHER_REASON,
  FEEDBACK_LOOP_REASON_TABLE,
  COMMENT_ONLY_REASON_LIST,
  COMMENT_WITH_URL_REASON_LIST,
  URL_FOR_COMMENT_WITH_URL_REASON_LIST,
  RECOMMENDATION_REASON_TO_COMMENT_TRANSLATOR,
  REASON_TABLE_NEW_I18N,
} from './reason-const';

export class DismissAllFeedbackForm extends React.PureComponent {
  static propTypes = {
    recommendationDescription: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    newI18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    type: PropTypes.string,
    permissions: PropTypes.objectOf(PropTypes.any),
  };

  static defaultProps = {
    type: '',
    permissions: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      reasonId: null,
      reasonNote: '',
    };
  }

  handleReasonChange = (e) => {
    this.setState({
      reasonId: e.target.id,
    });
  };

  handleCommentsChange = (value) => {
    this.setState({
      reasonNote: value,
    });
  };

  handleCommentsFocus = () => {
    if (this.state.reasonId === null) {
      this.setState({
        reasonId: OTHER_REASON,
      });
    }
  };

  render() {
    const { reasonId, reasonNote } = this.state;
    const {
      recommendationDescription,
      i18n,
      newI18n,
      onSubmit,
      onCancel,
      type,
      permissions,
    } = this.props;
    const isProductFeedbackLoop = permissions.IsRecommendationInProductFeedbackLoopEnabled;
    let reasonIds = REASON_TABLE.default;

    if (type in REASON_TABLE) {
      reasonIds = REASON_TABLE[type];
    }

    if (isProductFeedbackLoop && type in FEEDBACK_LOOP_REASON_TABLE) {
      reasonIds = FEEDBACK_LOOP_REASON_TABLE[type];
    }

    let useNewI18n = false;
    let reasonWithNewI18n;
    if (!_.isUndefined(REASON_TABLE_NEW_I18N[type])) {
      useNewI18n = true;
      reasonWithNewI18n = REASON_TABLE_NEW_I18N[type];
    }

    const title = i18n.getString('Recommendation_Feedback_Dismiss_All_Title', { recommendationDescription });

    const submitText = i18n.getString('Recommendation_Feedback_Submit_Action');

    const submitDisabled = reasonId === null;

    return (
      <div className="dismiss-all-recommendation-feedback-form">
        <button
          className="close closeimage"
          onClick={onCancel}
          aria-label={i18n.getString('Button_Close')}
        />
        <div className="dismiss-all-recommendation-feedback-form-head">
          <div className="dismiss-all-recommendation-feedback-form-title">{title}</div>
          <div>{isProductFeedbackLoop ?
            i18n.getString('Recommendation_Product_Feedback_Loop_Make_Better_Description')
            : i18n.getString('Recommendation_Feedback_Make_Better_Description')}
          </div>
        </div>

        <React.Fragment>
          <div className="reasons form-group">
            {_.map(reasonIds, (id, index) => (
              <Radio
                key={id}
                id={id}
                name="reason"
                checked={id === reasonId}
                value={id}
                onChange={this.handleReasonChange}
              >
                {useNewI18n && newI18n.getString(reasonWithNewI18n[id])}
                {!useNewI18n && i18n.getString(`Recommendation_Feedback_Reason_${id}`)}
                {_.isEqual(id, reasonId) && _.isEqual(index, reasonIds.length - 1) &&
                  <div className="comments form-group">
                    <CommentsField
                      id="comments"
                      value={reasonNote}
                      onChange={this.handleCommentsChange}
                      i18n={i18n}
                      onFocus={this.handleCommentsFocus}
                      isProductFeedbackLoop={isProductFeedbackLoop}
                    />
                  </div>
                }
                {_.isEqual(id, reasonId) && COMMENT_ONLY_REASON_LIST.includes(id) &&
                  <div className="reason-comment">
                    {i18n.getString(RECOMMENDATION_REASON_TO_COMMENT_TRANSLATOR[reasonId])}
                  </div>
                }
                {_.isEqual(id, reasonId) && COMMENT_WITH_URL_REASON_LIST.includes(id) &&
                  <div className="reason-comment">
                    <a
                      href={URL_FOR_COMMENT_WITH_URL_REASON_LIST[
                        COMMENT_WITH_URL_REASON_LIST[reasonId]]}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      {i18n.getString(RECOMMENDATION_REASON_TO_COMMENT_TRANSLATOR[reasonId])}
                    </a>
                  </div>
                }

              </Radio>
            ))}
          </div>
        </React.Fragment>

        <div className="actions form-inline">
          <button
            disabled={submitDisabled}
            className="btn btn-hero btn-primary submit"
            onClick={() => onSubmit({
              ReasonId: reasonId,
              ReasonNote: reasonNote,
            })}
          >
            {submitText}
          </button>
        </div>
      </div>
    );
  }
}
